import { createRouter, createWebHashHistory } from "vue-router";
import Event from "../views/Events.vue";
import Invitations from "../views/Invitations.vue";
import EventDetail from "../views/EventDetail.vue"; // Import the EventDetail component
import ScanAttendee from "../views/ScanAttendee.vue"; // Import the ScanAttendee component
import Login from "../views/Login.vue"; // Import the Login component
import Dashboard from "../views/Dashboard.vue"; // Import the Dashboard component
import AboutView from "../views/AboutView.vue"; // Import the About component
import Help from "../views/Help.vue"; // Import the Help component
import Unauthorized from "../views/Unauthorized.vue"; // Import the Unauthorized component
import axios from "axios";

const routes = [
  {
    path: "/",
    name: "home",
    meta: { requiresAuth: true, allowedRoles: ["Admin"] },
    component: Event,
  },
  {
    path: "/events/:id", // Dynamic route to view a single event
    name: "event-detail",
    component: EventDetail,
    meta: { requiresAuth: true, allowedRoles: ["Admin"] },
    props: true, // Pass route params as props
  },
  {
    path: "/Invitation",
    name: "invitation",
    meta: { requiresAuth: true, allowedRoles: ["Admin"] },
    component: Invitations,
  },
  {
    path: "/scan-attendee",
    name: "scan-attendee",
    meta: { requiresAuth: true, allowedRoles: ["Operator", "Admin"] },
    component: ScanAttendee,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: { requiresAuth: true, allowedRoles: ["Admin"] },
    component: Dashboard,
  },
  {
    path: "/about",
    name: "about",
    component: AboutView,
    meta: { requiresAuth: true, allowedRoles: ["Admin"] },
  },
  {
    path: "/help",
    name: "help",
    component: Help,
    meta: { requiresAuth: true, allowedRoles: ["Admin"] },
  },
  {
    path: "/unauthorized",
    name: "unauthorized",
    component: Unauthorized,
    meta: { requiresAuth: true, allowedRoles: ["Admin", "Operator"] },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  if (to.meta.requiresAuth && !token) {
    return next("/login");
  }
  if (to.meta.allowedRoles && !to.meta.allowedRoles.includes(user.role)) {
    return next("/unauthorized"); // or redirect to a "Not Authorized" page
  }

  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  next();
});

export default router;
